var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberContactInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.152377 26.4361V4.76942L6.48568 0.179688L12.819 4.76942V8.43612H25.8446V26.4361H0.152377ZM2.15231 24.4361H5.48568V21.1028H2.15231V24.4361ZM2.15231 19.1028H5.48568V15.7694H2.15231V19.1028ZM2.15231 13.7695H5.48568V10.4361H2.15231V13.7695ZM2.15231 8.43612H5.48568V5.10276H2.15231V8.43612ZM7.48564 8.43612H10.819V5.10276H7.48564V8.43612ZM7.48564 24.4361H23.8446V10.4361H7.48564V24.4361ZM15.7421 15.7694V13.7695H20.6651V15.7694H15.7421ZM15.7421 21.1028V19.1028H20.6651V21.1028H15.7421ZM10.819 15.7694V13.7695H12.819V15.7694H10.819ZM10.819 21.1028V19.1028H12.819V21.1028H10.819Z",
    fill: "#434545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberContactInfo);
export default __webpack_public_path__ + "static/media/member-contact-info.a9e543172076fbf4e473b2bae77b7573.svg";
export { ForwardRef as ReactComponent };